import { useStore } from '@tanstack/react-form';
import { Checkbox, Input, Text } from '@ui/themed';
import { t } from 'i18next';
import { useCustomerGroupsQuickSetupForm } from '../../hooks/use-customer-groups-quick-setup-form';
import {
  type CustomerGroupQuickSetupState,
  QUICK_SETUP_MIN_ORDER_REQUIREMENTS,
} from '../../types/customer-group-quick-setup.schema';

function OrderRequirementInput(props: {
  requirement: CustomerGroupQuickSetupState['minOrderRequirements'][number];
}) {
  const form = useCustomerGroupsQuickSetupForm();
  const currency = useStore(form.store, (state) => state.values.baseCurrency);

  const orderRequirementField =
    props.requirement === 'value_based_min' ? 'minOrderValue' : 'minOrderUnits';
  const orderRequirementI18nKey =
    props.requirement === 'value_based_min' ? 'min_order_value' : 'min_order_units';
  const suffix =
    props.requirement === 'value_based_min'
      ? currency
      : t(
          'features:customer_group.components.quick_setup.min_order_requirements.order_based_min.suffix',
        );

  return (
    <form.Field name={orderRequirementField}>
      {(field) => (
        <Input
          placeholder={t(
            `features:customer_group.components.quick_setup.${orderRequirementI18nKey}.placeholder`,
          )}
          inputMode="numeric"
          value={field.state.value ?? ''}
          onChange={field.handleChange}
          error={field.state.meta.errors[0]?.message}
          suffix={suffix}
        />
      )}
    </form.Field>
  );
}

export function MinOrderRequirementsField() {
  const form = useCustomerGroupsQuickSetupForm();

  return (
    <form.Field name="minOrderRequirements">
      {(field) => (
        <div className="flex flex-col gap-2">
          <Text>
            {t('features:customer_group.components.quick_setup.min_order_requirements.label')}
          </Text>
          {QUICK_SETUP_MIN_ORDER_REQUIREMENTS.map((req) => (
            <Checkbox
              key={req}
              label={t(
                `features:customer_group.components.quick_setup.min_order_requirements.${req}.label`,
              )}
              checked={field.state.value.includes(req)}
              onChange={() => {
                const current = field.state.value;

                // Toggle - add if not in list, remove if already in list
                field.handleChange(
                  current.includes(req) ? current.filter((v) => v !== req) : [...current, req],
                );
              }}
            >
              <OrderRequirementInput requirement={req} />
            </Checkbox>
          ))}
        </div>
      )}
    </form.Field>
  );
}
